// 本体の既存階層はコンフリクト対策で移動しない.新しいファイルを追加する場合もそちらへ.
export * from "../../../../../components/document/editor";

// 以下を↑のindex.tsに追加するとDocumentRegistererでRequestedDocumentProcessorが生成できずエラーが出る.(何らか循環参照が起きてる？)
// 一旦ここで直接exportを書いて回避.
export { default as CommonComponentsContainer } from "../../../../../components/document/editor/CommonComponentsContainer.vue";
